import SmoothScrollIntoView from '../__utils/smoothScrollIntoView';
import Forms from '../__utils/forms';
import viewportUnits from '../__utils/viewportUnits';
import delayedScripts from '../__utils/delayedScripts';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		document.querySelector('html').classList.remove('no-js');
		SmoothScrollIntoView();
		viewportUnits();
		delayedScripts();
	},
	loaded() {
		// Only add functions here that are okay to run after the entire page has loaded (include media/images).
		Forms();
		viewportUnits();
		SmoothScrollIntoView();
	},
	resized() {
		viewportUnits();
		SmoothScrollIntoView();
	},
	scrolled() {},
	keyDown() {
		SmoothScrollIntoView();
	},
	mouseUp() {},
};
export default controller;
